//首页交互
(function($, undefined){
	if(!$('.J_k_homeBox').length)return false;
	var	$doc	=	$(document);
	//首页轮播图
	(function(){
		var	$box	=	$('[data-name="imgList"]'),
			$ul		=	$box.children('[data-name="img"]'),
			$li		=	$ul.children('li'),
			_index	=	0,
			html	=	'',
			move,round,timer;
		if($li.length <= 1)return false;
		$ul.width($li.length*$li.eq(0).outerWidth(true));
		(function(){
			html	+=	'<ul class="roundList" data-name="roundList">';
			for(var	i=0,max=$li.length; i<max; i++){
				html	+=	'<li'+ (i?'':' class="active"') +'><a href="javascript:;"></a></li>';
			};
			html	+=	'</ul>';
		})();
		$(html).appendTo($box).on('click','li',function(){
			_index	=	$(this).index();
			clearTimeout(timer);
			move(_index);
			round();
			return false;
		});
		move	=	function(index){
			$ul.stop(true).animate({'marginLeft':-$li.width()*index},600);
			$('[data-name="roundList"] li').eq(index).addClass('active').siblings().removeClass('active');
		};
		(round	=	function(){
			timer	=	setTimeout(function(){
				_index	=	(_index >= ($li.length-1)? 0 : _index+1);
				move(_index);
				round();
			},4000);
		})();
		$li.hover(function(){
			clearTimeout(timer);
		},function(){
			round();
		});
	})();

	$doc.on('click','.J_k_btn',function(){
		$(this).addClass('active').siblings().removeClass('active');
	});
})(jQuery);

//首页简版交互
(function($, document, undefined){
	if(!$('.J_k_gztBox').length)return false;
	var	_page	=	0;
	//滚轮翻页方法
	function page(){
		$('.J_k_centerBox').stop().animate({'marginTop':$('.J_k_gztBox').height()*-_page});
	};
	(init	=	function(){
		$('.J_k_contentList>.content').eq(0).show();
	})();
	$(document).on('mousewheel',function(){
		var	e	=	e	||	window.event;
		if(e.wheelDelta < 0 && _page < 1){
			_page++;
		}else if(e.wheelDelta > 0 && _page > 0){
			_page--;
		};
		page();
	}).on('DOMMouseScroll',function(e){
		var	e	=	e	||	window.event;
		if(e.detail > 0 && _page < 1){
			_page++;
		}else if(e.detail < 0 && _page > 0){
			_page--;
		};
		page();
	}).on('click','.J_k_tabPage>a',function(){
		var	$this	=	$(this),
			index	=	$this.index();
		$this.addClass('active').siblings().removeClass('active');
		$('.J_k_contentList>.content').eq(index).show().siblings().hide();
	});
	$(window).on('resize',function(){
		page();
	});
})(jQuery, document);

//培训信息列表页交互
(function($, document, undefined){
	// 递归展开父级
	var openTree = function(el){
		var $li = el.parents('li').eq(0);
		if($li.length){
			$li.addClass('open');
			openTree($li);
		};
	};
	// 树形栏目列表
	(function init(){
		var $active = $('[data-name="fileTreeBox"] li.active');
		if($active.length){
			openTree($active);
		};
	})();
	$(document).on('click','[data-name="fileTreeBox"] a',function(){
		var $li = $(this).parent('li');
		if($li.children('ul').length){
			$li[$li.hasClass('open')?'removeClass':'addClass']('open');
			return false;
		}
		$('[data-name="fileTreeBox"] li').removeClass('active');
		$li.addClass('active');
	});
})(jQuery, document);

